import ModuleLayout from "@/components/admin/ModuleLayout"
import CalendlyConnectionPanel from "@/components/settings/CalendlyConnectionPanel"
import MeetAvailabilityPanel from "@/components/settings/MeetAvailabilityPanel"
import { accountTabs } from "./accountTabs"

export default function AccountIntegrationsPage() {
  return (
    <ModuleLayout
      breadcrumbs={[{ label: "SateLab", to: "/" }, "Mi cuenta"]}
      title="Mi cuenta"
      subtitle="Administra tu perfil, tu contraseña y tus integraciones personales."
      tabs={accountTabs("integrations")}
      metrics={[]}
    >
      <CalendlyConnectionPanel />
      <MeetAvailabilityPanel />
    </ModuleLayout>
  )
}
